<template>
  <div class="asd20-school-directory__map-view">
    <l-map
      ref="map"
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
    >
      <l-tile-layer
        :url="url"
        :attribution="attribution"
      />
      <l-marker
        v-for="school in schools"
        :key="school.abbreviation"
        :lat-lng="calculateSchoolLatLng(school)"
        :options="{ riseOnHover: true }"
      >
        <l-tooltip :options="{ permanent: false, interactive: false, opacity: 1 }"><span v-html="school.title.replace(/(Elementary|Middle|High) School/, '<small>$1 School</small>')"/></l-tooltip>
        <l-popup :options="{ permanent: false, interactive: true, opacity: 1 }">
          <h2 v-html="school.title.replace(/(Elementary|Middle|High) School/, '<small>$1 School</small>')"/>
          <p><small>{{ school.address.street1 }}, {{ school.address.zip }}</small></p>
          <asd20-button
            size="sm"
            label="View Profile"
            transparent
            bordered
            @click.native="onSelect(school)" />
        </l-popup>
      </l-marker>
      <l-circle-marker :lat-lng="center" />

    </l-map>
  </div>
</template>

<script>
import { get } from 'vuex-pathify'
import Asd20Button from '@asd20/ui/src/components/atoms/Asd20Button'
import { LMap, LTileLayer, LMarker, LCircleMarker, LPopup, LTooltip } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

export default {
  name: 'Asd20SchoolDirectoryMapView',

  components: {
    Asd20Button,
    LMap,
    LTileLayer,
    LMarker,
    LCircleMarker,
    LPopup,
    LTooltip
  },

  props: {
    schools: { type: Array, default: () => [] }
  },

  data: () => ({
    zoom: 12,
    currentZoom: 12,
    currentCenter: L.latLng(38.874618840745, -104.78432065169511),
    mapOptions: {
      zoomSnap: 0.5
    },
    // url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
    url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
    // url: 'https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
  }),

  computed: {
    center() {
      let userLocation = this.$store.getters['location/userLocation']
      if (!!userLocation) {
        return L.latLng(userLocation.lat, userLocation.lon)
      }
      return L.latLng(38.970307630102575, -104.79351863265038)
    }
  },

  methods: {
    zoomUpdate (zoom) {
      this.currentZoom = zoom
    },
    centerUpdate (center) {
      this.currentCenter = center
    },
    calculateSchoolLatLng(school) {
      return L.latLng(Number(school.location.lat), Number(school.location.lon))
    },
    onSelect(school) {
      this.$emit('select', school)
    }
  }
}
</script>

<style lang="scss">
@import '@asd20/ui/src/design/_mixins.scss';
@import '@asd20/ui/src/design/_variables.scss';

.asd20-school-directory__map-view {
  position: relative;
  flex-grow: 1;
  .leaflet-container {
    position: absolute;
  }
  .leaflet-tile-pane {
    filter: sepia(1) hue-rotate(180deg) grayscale(0.75);
  }
  .leaflet-popup-content-wrapper {
    border-radius: 0;
  }
  .leaflet-popup-content {
    margin: space(0.5);
    h2 {
      color: asd20-swatch('primary');
      font-size: 1rem;
      margin-bottom: space(0.25);
      small {
        display: block;
        font-size: 0.75em;
        opacity: 1;
        color: asd20-swatch('accent-one');
      }
    }
    p {
      margin: 0 0 space(0.5) 0;
    }
  }
}
</style>
